import React from "react";
import { Eyebrow } from "./Primitives";

export default function PageHero({ eyebrow, title, subtitle, image }) {
  return (
    <section className="bg-[#F9F6F0]" data-testid="page-hero">
      <div className="mx-auto grid max-w-6xl items-center gap-8 px-5 py-14 sm:px-8 sm:py-20 lg:grid-cols-2">
        <div className="fade-up">
          {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
          <h1 className="mt-3 font-display text-4xl leading-tight tracking-tight sm:text-5xl">{title}</h1>
          {subtitle && <p className="mt-4 max-w-xl text-lg text-[#5C6370]">{subtitle}</p>}
        </div>
        {image && (
          <img src={image} alt="" loading="eager"
            className="aspect-[4/3] w-full rounded-3xl object-cover shadow-md fade-up" style={{ animationDelay: "0.1s" }} />
        )}
      </div>
    </section>
  );
}
